/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileReportData } from '../../models/profile-report-data';

export interface ProfileReportAveragesData$Params {

/**
 * ID of profile
 */
  id: number;

/**
 * Type of averages (see more type ProfileReportAveragesType)
 */
  type: string;
  from: number;
  to: number;
}

export function profileReportAveragesData(http: HttpClient, rootUrl: string, params: ProfileReportAveragesData$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportData>> {
  const rb = new RequestBuilder(rootUrl, profileReportAveragesData.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
    rb.path('from', params.from, {});
    rb.path('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileReportData>;
    })
  );
}

profileReportAveragesData.PATH = '/rest/profile/{id}/report/market/{type}/{from}/{to}';
